import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/american_pub_poker.jpg';

function Sidebar({ user, onLogout }) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  // Auto-close sidebar on navigation
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const getInitials = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
    }
    return user?.username?.[0]?.toUpperCase() || 'A';
  };

  const getDisplayName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName[0]}.`;
    }
    return user?.username || 'Admin';
  };

  return (
    <>
      <button
        className="hamburger-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle navigation"
      >
        {mobileOpen ? '\u2715' : '\u2630'}
      </button>

      {mobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <aside className={`sidebar ${mobileOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} alt="American Pub Poker" className="sidebar-logo" />
          <p>League Admin</p>
        </div>

        <nav>
          <ul className="sidebar-nav">
            <li>
              <Link to="/dashboard" className={isActive('/dashboard')}>
                <span className="nav-icon">📊</span>
                Dashboard
              </Link>
            </li>
            <li>
              <Link to="/leagues" className={isActive('/leagues')}>
                <span className="nav-icon">🏆</span>
                Leagues
              </Link>
            </li>
            <li>
              <Link to="/venues" className={isActive('/venues')}>
                <span className="nav-icon">📍</span>
                Venues
              </Link>
            </li>
            <li>
              <Link to="/schedules" className={isActive('/schedules')}>
                <span className="nav-icon">📅</span>
                Schedules
              </Link>
            </li>
            <li>
              <Link to="/games" className={isActive('/games')}>
                <span className="nav-icon">🎴</span>
                Games
              </Link>
            </li>
            <li>
              <Link to="/promotions" className={isActive('/promotions')}>
                <span className="nav-icon">🏅</span>
                Promotions
              </Link>
            </li>
            <li>
              <Link to="/championship" className={isActive('/championship')}>
                <span className="nav-icon">🏆</span>
                Championship
              </Link>
            </li>
            <li>
              <Link to="/dealer-schedule" className={isActive('/dealer-schedule')}>
                <span className="nav-icon">📆</span>
                Dealer Schedule
              </Link>
            </li>
            <li>
              <Link to="/notifications" className={isActive('/notifications')}>
                <span className="nav-icon">📱</span>
                Notifications
              </Link>
            </li>
            <li>
              <Link to="/reports" className={isActive('/reports')}>
                <span className="nav-icon">📋</span>
                Reports
              </Link>
            </li>
            <li>
              <Link to="/users" className={isActive('/users')}>
                <span className="nav-icon">👥</span>
                Users
              </Link>
            </li>
            <li>
              <Link to="/duplicates" className={isActive('/duplicates')}>
                <span className="nav-icon">🔀</span>
                Duplicates
              </Link>
            </li>
            <li>
              <Link to="/kiosk" className={isActive('/kiosk')}>
                <span className="nav-icon">🖥️</span>
                Kiosk Mode
              </Link>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{getInitials()}</div>
            <div className="user-details">
              <div className="user-name">{getDisplayName()}</div>
              <div className="user-role">League Admin</div>
            </div>
          </div>
          <button className="logout-button" onClick={onLogout}>
            Sign Out
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
